import React, { useEffect, useState } from 'react';
import axios from 'axios'
import {getCookie} from '../../common/utils/auth'
import { Table, Space, Spin } from 'antd';
import { config } from "enviroment.js"
import "antd/dist/antd.css";
import './Admin.scss';
import AdminPageHeader from './AdminPageHeader'

const columns = [
  {
    title: 'Store',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Remote Adventure',
    dataIndex: 'name',
    key: 'name',
    render: text => text.replace(' (Remote Adventure)', ''),
  },
  {
    title: 'Actions',
    key: 'action',
    render: (text, record) => (
      <Space size="middle">
        <a href={'/admin/experiences/' + record.experiences_id}>Edit</a>
      </Space>
    ),
  },
];

const ExperienceListView = () => {
  const [experiences, setExperiences] = useState([])
  const [loading, setLoading] = useState({ status: true, type: 'page' })
  const [error, setError] = useState({ status: false })

  useEffect(() => {
		axios.get(config.raUrl + `/admin/experiences/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getCookie('token')}`
      }
    })
			.then((res) => {
        setExperiences(res.data)
        setLoading({ status: false })
			}).catch((err) => {
        console.log("error caught: ", err.response)
        let errorMessage = {
          status: true,
          text: 'Ooops!',
          sub: 'Something went wrong.'
        }
        if (err.response.status === 401) {
          errorMessage.text = 'Unauthorized'
          errorMessage.sub = 'You are not authorized to view this page.'
        }
        setError(errorMessage)
        setLoading({ status: false })
			})
  }, [])

  return (
    <Spin spinning={loading.status} size="large" className={loading.status && loading.type}>
      {error.status
        ? (
          <>
          <div className="error-container">
            <div className="error-text">{error.text}</div>
            <div className="error-sub">{error.sub}</div>
          </div>
          </>
        ) : (
          <>
          <AdminPageHeader
            title="Experiences"
          />
          <Table dataSource={experiences} columns={columns} rowKey="experiences_id" />
          </>
        )
      }
    </Spin>
  )
}
export default ExperienceListView;
